"use client";

import dynamic from "next/dynamic";

const VolumeBotYouTubeEmbed = dynamic(
  () => import("@/components/volume-bot/VolumeBotYouTubeEmbed"),
  {
    ssr: false,
    loading: () => (
      <div
        className="mx-auto mb-8 min-h-[220px] max-w-5xl rounded-2xl border border-white/10 bg-white/[0.03] sm:mb-12 sm:min-h-[280px] [content-visibility:auto]"
        aria-hidden
      />
    ),
  },
);

export default function VolumeBotYouTubeEmbedLazy() {
  return <VolumeBotYouTubeEmbed />;
}
